import {defaultTo, last, pipe, prop, sortBy} from 'ramda';

import {InterestActiveBusinessCaseResponseBodyV2} from '@dms/api/finance';

import {Nullish} from 'shared/web';

export const getLastActiveBusinessCase = pipe<
  [InterestActiveBusinessCaseResponseBodyV2[] | Nullish],
  InterestActiveBusinessCaseResponseBodyV2[],
  InterestActiveBusinessCaseResponseBodyV2[],
  InterestActiveBusinessCaseResponseBodyV2 | undefined
>(defaultTo([]), sortBy(prop('createdAt')), last);
